module.exports = __webpack_public_path__ + "img/img_zixun.6b2da2ab.jpg";